var map = {
	"./prism-coy.css": 62136,
	"./prism-coy.min.css": 51585,
	"./prism-dark.css": 58314,
	"./prism-dark.min.css": 32029,
	"./prism-funky.css": 79748,
	"./prism-funky.min.css": 78956,
	"./prism-okaidia.css": 73692,
	"./prism-okaidia.min.css": 85008,
	"./prism-solarizedlight.css": 89776,
	"./prism-solarizedlight.min.css": 45464,
	"./prism-tomorrow.css": 54600,
	"./prism-tomorrow.min.css": 17699,
	"./prism-twilight.css": 65044,
	"./prism-twilight.min.css": 60173,
	"./prism.css": 87398,
	"./prism.min.css": 52966
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49580;